import { BodyConverter } from '@iotize/tap/client/api';
import { StringConverter } from '@iotize/tap/client/impl';

import { VariableMeta } from '../generated/models';

export class VariableMetaConfigConverter
  implements BodyConverter<Partial<VariableMeta>>
{
  public utf8Converter = new StringConverter('utf8');

  public encode(data: Partial<VariableMeta>): Uint8Array {
    return this.utf8Converter.encode(`${data.name || ''}:${data.unit || ''}`);
  }

  public decode(data: Uint8Array): Partial<VariableMeta> {
    const str = this.utf8Converter.decode(data);
    const output = str.split(':');
    return {
      name: output[0],
      unit: output.length >= 2 ? output[1] : '',
    };
  }
}
